import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'

export const useFundraiserUpdatesPublicStore = (id = 'default') => {
  return defineStore({
    id: `fundraiserUpdatesPublic_${id}`,
    state: () => ({
      items: [],
      api: '/api/v1/fundraiser-updates-public'
    }),
    getters: {
      ...getters,
      getItemsByUpdatable (state) {
        return (params) => state.items.filter(item => item.updatable_type === params.updatable_type && item.updatable_id === params.updatable_id)
      }
    },
    actions: {
      ...actions
    }
  })()
}
